<script lang="ts">
  import { timeSince } from '$utils';
  import type { Notification } from '$shared/lib';
  import NotificationTypeSymbol from './NotificationTypeSymbol.svelte';
  import NotificationSeenSetter from './NotificationSeenSetter.svelte';
  import UserPlusIcon from '$lib/icons/users/UserPlusIcon.svelte';
  import { handleNotificationClick } from '$lib/utils/notifications';

  export let notification: Notification;

  function onNotificationClick() {
    handleNotificationClick(notification);
  }
</script>

<a
  href={`/projects/explore/${notification.urlSlug}`}
  on:click={onNotificationClick}
  class:bg-mint-dark-1={!notification.isRead}
  class:border-mint-dark-6={!notification.isRead}
  class="border-gray-dark-4 relative flex w-full items-start gap-x-6 rounded border p-6"
>
  <NotificationTypeSymbol isRead={notification.isRead}>
    <UserPlusIcon class="text-gray-dark-12" />
  </NotificationTypeSymbol>

  <div class="flex-1 space-y-3 overflow-hidden">
    <h2 class="text-base">Added to new team</h2>

    <div class="text-gray-dark-11 max-h-[60px] overflow-hidden shadow-inner">
      "{notification.contentBody}" has added you to their hackathon team.
    </div>

    <h3 class="text-gray-dark-11">
      {notification.createdAt && timeSince(new Date(notification.createdAt))}
    </h3>
  </div>
  {#if !notification.isRead}
    <NotificationSeenSetter bind:notificationId={notification.id} />
  {/if}
</a>
